<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <span v-bind="props" class="sort-title">
        <span class="sort-label">{{ title }} {{ selectedTitle }}</span> <v-icon size="20">mdi-menu-down</v-icon>
      </span>
    </template>

    <v-list>
      <v-list-item
        :key="index"
        v-for="(item, index) in items"
        @click="selectSort(item)"
        :class="{'sort-item': true, 'active': selectedTitle === item.title}"
      >
        <v-list-item-title>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'SortDropdown',
  props: {
    items: {
      type: Array,
      required: true
    },
    defaultValue: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'Sort by:'
    },
    defaultSelection: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedTitle: this.getInitialTitle()
    }
  },
  methods: {
    getInitialTitle () {
      // Check if defaultValue matches any of the item values
      const selectedItem = this.items.find(item => item.value === this.defaultValue)
      return selectedItem ? selectedItem.title : this.defaultSelection
    },
    selectSort (item) {
      this.selectedTitle = item.title
      this.$emit('onSelect', item.value)
    }
  }
}
</script>

<style scoped>
.sort-title {
  gap: 4px;
  padding: 2px;
  cursor: pointer;
  align-items: center;
  display: inline-flex;
}

.sort-title {
  color: var(--text-dark);
  font-size: 14px;
  font-weight: 400;
}
</style>
